export const prime = {
  accept: 'Sí',
  addRule: 'Agregar regla',
  am: 'AM',
  apply: 'Aplicar',
  cancel: 'Cancelar',
  choose: 'Escoger',
  chooseDate: 'Elige fecha',
  chooseMonth: 'Elige el mes',
  chooseYear: 'Elige Año',
  clear: 'Limpiar',
  completed: 'Terminado',
  contains: 'Contenga',
  custom: 'Personalizar',
  dateAfter: 'Fecha después de',
  dateBefore: 'Fecha antes de',
  dateFormat: 'dd/mm/yy',
  dateIs: 'Fecha igual a',
  dateIsNot: 'Fecha diferente a',
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  emptyFilterMessage: 'Sin opciones disponibles',
  emptyMessage: 'No se han encontrado resultados',
  emptySearchMessage: 'Sin opciones disponibles',
  emptySelectionMessage: 'Ningún artículo seleccionado',
  endsWith: 'Termine con',
  equals: 'Igual a',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  filter: 'Filtrar',
  firstDayOfWeek: 1,
  gt: 'Mayor que',
  gte: 'Mayor o igual que',
  lt: 'Menor que',
  lte: 'Menor o igual que',
  matchAll: 'Coincidir todos',
  matchAny: 'Coincidir alguno',
  medium: 'Mediano',
  monthNames: [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
  ],
  monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  nextDecade: 'Próxima década',
  nextHour: 'Próxima hora',
  nextMinute: 'Próximo minuto',
  nextMonth: 'Próximo mes',
  nextSecond: 'Próximo segundo',
  nextYear: 'Próximo año',
  noFilter: 'Sin filtro',
  notContains: 'No contenga',
  notEquals: 'Diferente de',
  now: 'Ahora',
  passwordPrompt: 'Introduce una contraseña',
  pending: 'Pendiente',
  pm: 'PM',
  prevDecade: 'Década anterior',
  prevHour: 'Hora anterior',
  prevMinute: 'Minuto anterior',
  prevMonth: 'Mes anterior',
  prevSecond: 'Segundo anterior',
  prevYear: 'Año anterior',
  reject: 'No',
  removeRule: 'Eliminar regla',
  searchMessage: '{0} resultados disponibles',
  selectionMessage: '{0} elementos seleccionados',
  showMonthAfterYear: false,
  startsWith: 'Empiece con',
  strong: 'Fuerte',
  today: 'Hoy',
  upload: 'Subir',
  weak: 'Débil',
  weekHeader: 'Sem',
  aria: {
    cancelEdit: 'Cancelar edición',
    close: 'Cerrar',
    collapseLabel: 'Colapsar',
    collapseRow: 'Colapsar fila',
    editRow: 'Editar fila',
    expandLabel: 'Expandir',
    expandRow: 'Expandir fila',
    falseLabel: 'Falso',
    filterConstraint: 'Restricción de filtro',
    filterOperator: 'Operador de filtro',
    firstPageLabel: 'Primera página',
    gridView: 'Vista de cuadrícula',
    hideFilterMenu: 'Ocultar menú de filtro',
    jumpToPageDropdownLabel: 'Saltar a la página',
    jumpToPageInputLabel: 'Saltar a la página',
    lastPageLabel: 'Última página',
    listView: 'Vista de lista',
    moveAllToSource: 'Mover todo al origen',
    moveAllToTarget: 'Mover todo al destino',
    moveBottom: 'Mover al fondo',
    moveDown: 'Mover hacia abajo',
    moveTop: 'Mover al principio',
    moveToSource: 'Mover al origen',
    moveToTarget: 'Mover al destino',
    moveUp: 'Mover hacia arriba',
    navigation: 'Navegación',
    next: 'Siguiente',
    nextPageLabel: 'Siguiente página',
    nullLabel: 'No seleccionado',
    otpLabel: 'Por favor, introduce el carácter de la contraseña de un solo uso {0}',
    pageLabel: 'Página {page}',
    previous: 'Anterior',
    previousPageLabel: 'Página anterior',
    removeLabel: 'Eliminar',
    rotateLeft: 'Girar a la izquierda',
    rotateRight: 'Girar a la derecha',
    rowsPerPageLabel: 'Filas por página',
    saveEdit: 'Guardar edición',
    scrollTop: 'Desplazarse hacia arriba',
    selectAll: 'Seleccionar todo',
    selectLabel: 'Seleccionar',
    selectRow: 'Seleccionar fila',
    showFilterMenu: 'Mostrar menú de filtro',
    slide: 'Diapositiva',
    slideNumber: '{slideNumber}',
    star: '1 estrella',
    stars: '{star} estrellas',
    trueLabel: 'Verdadero',
    unselectAll: 'Deseleccionar todo',
    unselectLabel: 'Deseleccionar',
    unselectRow: 'Deseleccionar fila',
    zoomImage: 'Ampliar imagen',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
  },
};
